import React, { Component } from 'react'
import Select from 'react-select';
import { MediaBaseUrl } from '../../../../../../actions/api';

export default class GoogleTab extends Component {
    state = { 
        accountOption: [],
        parentOption: []
    }

    componentDidMount() {
        this.getChildAccountData()
    }
    componentWillReceiveProps(nextProps) {

        if (nextProps.connectedAcc !== this.state.parentOption) {
            this.getChildAccountData()
        }
    }
    getChildAccountData = () => {
        const { connectedAcc } = this.props;
        if (connectedAcc && connectedAcc.length) {
            var data = connectedAcc.map((f, i) => {
                return ({ 'label': f.ConnectedAccounts.accountName, 'value': f.ConnectedAccounts.id })
            })

            data.push({ 'label': "Other", 'value': 0 });
            this.setState({ parentOption: data });
        }

    }

    onAccountIdChange = (value) => {
        const { childAcc } = this.props
        if (value == 0) {
            this.props.onAccountChildChange(value)
        }
        else {
            var mainAccountId = childAcc.filter(f => f.ConnectedAccounts.id == value)
            this.props.onAccountChildChange(value)
            this.props.onConnectedAccountChange(mainAccountId[0].ConnectedAccounts.parent)
        }
    }

    onParentSelected = (value) => {

        const { connectedAcc } = this.props
        this.props.onConnectedAccountChange(value);
        let childAcccounts = [];
        if (value !== 0) {
            const selectedAcc = connectedAcc.filter(account => account.ConnectedAccounts.id == value);
            childAcccounts = selectedAcc[0].ConnectedAccounts.child.map((f) => {
                return ({ 'label': f.ConnectedAccounts.value2, 'value': f.ConnectedAccounts.id })
            });
            childAcccounts.push({ 'label': "Other", 'value': 0 });
        } else {
            this.props.onAccountChildChange(0);
        }

        this.setState({accountOption: childAcccounts });
    }


    render() {


        const { onAddAccount, otherAccount,  connetedAccount, accountChild, onotherAccount } = this.props
        const { accountOption, parentOption } = this.state;

        return (
            <>
                <div className="row">
                    <div className="col-md-6">
                        <label>Select Account</label>
                        <Select options={parentOption} classNamePrefix="selectpicker" defaultValue={connetedAccount} onChange={(e) => { this.onParentSelected(e.value); onotherAccount(e.value == 0 ? true : false) }} className="addFeedGoogle" />
                        <br />
                    </div>

                    <div className="col-md-6">
                        <label>Select Place </label>
                        <Select options={connetedAccount ? accountOption : []} classNamePrefix="selectpicker" defaultValue={accountChild} onChange={(e) => { this.onAccountIdChange(e.value); onotherAccount(e.value == 0 ? true : false) }} className="addFeedGoogle" />
                        <br />
                    </div>
                </div>


                {otherAccount ?
                    <div className="otherSection text-center">
                        <div className="py-3">
                            <a className="btn btn-outline-gray btn-lg w-auto btn-clean d-inline-flex align-items-center btn-lg px-3">
                                <span className="symbol symbol-25 me-3">
                                    <img src={`${MediaBaseUrl}social-icons/google.svg`} alt="" />
                                </span>
                                <span className="text-dark-50 font-weight-bolder font-size-base" onClick={onAddAccount}>Connect Google</span>
                            </a>
                        </div>
                    </div> : null}
            </>
        )
    }
}
